import React, { useState, useEffect, useCallback } from 'react';
import { View } from 'react-native';

import GroupList from '../GroupList';

import { CommonStyles } from '../../styles';
import Images from '../../constants/Images';
import { getCreditCard, getCardBillingDetails } from '../../services/api/profile.service';

import { getCountries } from '../../utils/country.utils';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';
import { Modals } from '../../constants/ScreenNames';
import { useNavigation, useFocusEffect } from '@react-navigation/native';

const getImage = (code) => {
  return code ? Images.creditCard[code.toLowerCase()] : null;
};

const getCreditCardSorted = async () => {
  const res = await getCreditCard();
  const GHOST_TYPE_NAME = 'ghost';
  return {
    list: res.CreditCardList.map((i) => ({
      label: 'XXXX XXXX XXXX ' + i.CreditCardLastFourDigitAsString,
      small: i.CreditCardDescription,
      icon: getImage(i.CreditCardVendorCode),
      data: i,
    })),
    types: res.CreditCardTypes.filter(
      (card) => card.CreditCardTypeName.toLowerCase() !== GHOST_TYPE_NAME
    ).map((card) => ({
      label: card.CreditCardTypeName,
      value: card.CreditCardType,
    })),
    cardProviders: res.CreditCardProviders.map((provider) => ({
      label: provider.CreditCardVendor,
      value: provider.CreditCardVendorCode,
    })),
  };
};

const CreditCardViewer = ({ isUpdateAllowed = true }) => {
  const { tKey } = useComponentTKey('CreditCardViewer');
  const { t } = useTranslation(i18nNS.me);
  const navigation = useNavigation();
  const [countryList, setCountryList] = useState([]);
  const [creditCardTypes, setCreditCardTypes] = useState([]);
  const [creditCardList, setCreditCardList] = useState([]);
  const [creditCardProviders, setCreditCardProviders] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigateToCreditCardModal = (creditCard = {}) => {
    navigation.navigate(Modals.CreditCardModal, {
      countryList,
      creditCard,
      creditCardTypes,
      creditCardProviders,
    });
  };
  const onAddPress = () => {
    navigateToCreditCardModal();
  };

  const onEditPress = async (index) => {
    if (creditCardList[index]) {
      const cc = creditCardList[index].data;
      const res = await getCardBillingDetails(cc);

      cc.BillingAddressType = res;
      navigateToCreditCardModal(cc);
    }
  };

  const refreshCreditCardList = () => {
    (async () => {
      setLoading(true);
      const creditCardSorted = await getCreditCardSorted();
      setCreditCardList(creditCardSorted.list);
      setCreditCardTypes(creditCardSorted.types);
      setCreditCardProviders(creditCardSorted.cardProviders);
      setLoading(false);
    })();
  };

  useEffect(() => {
    refreshCreditCardList();

    (async () => {
      const res = await getCountries();
      setCountryList(res);
    })();
  }, []);

  useFocusEffect(
    useCallback(() => {
      refreshCreditCardList();
    }, [])
  );

  return (
    <View style={CommonStyles.py3}>
      <GroupList
        title={t(tKey('CreditCard'))}
        items={creditCardList}
        onAddPress={onAddPress}
        loading={loading}
        onEditPress={onEditPress}
        isUpdateAllowed={isUpdateAllowed}
      />
    </View>
  );
};

export default CreditCardViewer;
